import styled from 'styled-components';
import MuiRadio from '@material-ui/core/Radio';

export const StyledMuiRadio = styled(MuiRadio)`
  border-radius: 4px;
  padding: 5px;
  display: inline-flex;
  align-items: center;

  &:not(.disabled):hover {
    background: #E1E9FA;
    cursor: pointer;

    .MuiRadio-root {
      background: transparent ;

      .MuiIconButton-label {
        color: #26427C;
      }
    }
  }

  &.disabled {
    .RadioLabel {
      color: #525866 !important;
    }

    .MuiIconButton-label {
      color: #CFD6E5 !important;
    }
  }

  &.green {
    .MuiRadio-root {
      &.Mui-checked .MuiIconButton-label {
        color: #30BF78;
      }
    }

    &:hover {
      .MuiRadio-root {
        .MuiIconButton-label {
          color: #30BF78;
        }
      }
    }
  }

  .RadioLabel {
    margin-left: 5px;
    color: rgba(0,0,0,0.6);
  }

  .MuiRadio-root {
    padding: 0;

    .MuiIconButton-label {
      color: #CFD6E6;
    }

    &.Mui-checked .MuiIconButton-label {
      color: #26427C;
    }
  }

`;
